import {
  WHATSON,
  BESTDEALS,
  ADVERTISEMENT,
  ANNOUNCEMENT,
  OTHERS,
} from './marketingContentType'

export default ({ type, contentType, customLabel }) => {
  let thisType
  if (type !== undefined) thisType = type
  else thisType = contentType
  switch (thisType) {
    case WHATSON:
      return { name: "What's On", type: WHATSON }
    case BESTDEALS:
      return { name: 'Best Deals', type: BESTDEALS }
    case ADVERTISEMENT:
      return { name: 'Special Feature', type: ADVERTISEMENT }
    case ANNOUNCEMENT:
      return { name: 'What’s New', type: ANNOUNCEMENT }
    default:
      return { name: customLabel || 'Others', type: OTHERS }
  }
}
